import { Flex, PageContent, PageHeader } from '@/components';
import { SegmentSwitcher } from '@/features/project/_components/SegmentSwitcher';
import { useTranslation } from 'react-i18next';
import { CreateOrganizationTemplateButton } from '../_components/CreateOrganizationTemplateButton';
import { OrganizationTemplateFormDrawer } from '../_components/OrganizationTemplateFormDrawer';
import { OrganizationTemplateListTable } from '../_components/OrganizationTemplateListTable';
import { OrganizationTemplateSearchAccordion } from '../_components/search-accordion/OrganizationTemplateSearchAccordion';

export const OrganizationTemplatesPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader
        title={t('projects-page')}
        breadcrumbs={[{ title: t('projects-page') }]}
        buttons={<CreateOrganizationTemplateButton />}
      />
      <PageContent>
        <Flex vertical gap={16}>
          <SegmentSwitcher segment="organization-template" />
          <OrganizationTemplateSearchAccordion />
          <OrganizationTemplateListTable />
          <OrganizationTemplateFormDrawer />
        </Flex>
      </PageContent>
    </>
  );
};
